import { render, staticRenderFns } from "./PriceTableInfo.vue?vue&type=template&id=49c8ab12&scoped=true&"
var script = {}
import style0 from "./PriceTableInfo.vue?vue&type=style&index=0&id=49c8ab12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c8ab12",
  null
  
)

export default component.exports